import { Flex, FlexProps } from '@chakra-ui/react';
import { ReactNode } from 'react';

type MainProps = {
  children: ReactNode;
} & FlexProps;

export const Main = ({ children, ...rest }: MainProps) => {
  return (
    <Flex as="main" align="center" flexDir="column" {...rest}>
      {children}
    </Flex>
  );
};
